import { AxiosResponse } from "axios";
import { Activity } from "../types/activity";
import { PrintHistoryRequest } from "../types/printHistoryRequest";
import { PrintParams } from "../types/printParams";
import { TestPrintParams } from "../types/testPrintParams";
import { isPrimaryAlternatingWorkorder } from "./activitiesHelper";
import { aplClient } from "./apiClient";
import { MerckLabel } from "../types/merckLabel";

const printPallets = (printParams: PrintParams): Promise<AxiosResponse<PrintHistoryRequest[], any>> => {
    return aplClient().post(`print`, printParams);
};

const printMerck = (merckLabel: MerckLabel, printerId: number): Promise<AxiosResponse<PrintHistoryRequest[], any>> => {
    return aplClient().post(`print/merck/${printerId}`, merckLabel);
};

const testPrintPallets = (printParams: TestPrintParams): Promise<AxiosResponse<PrintHistoryRequest, any>> => {
    return aplClient().post(`testprint`, printParams);
};

const getNumberOfPalletsToPrint = (activity: Activity, offline: boolean, count: number) => {
    if (offline) {
        // when offline
        if (count === 0) {
            return 0;
        } else {
            return count;
        }
    } else {
        // when online
        if (activity.siteId === 5 && !offline && isPrimaryAlternatingWorkorder(activity)) {
            return 2;
        } else {
            return 1;
        }
    }
};

export { printPallets, printMerck, testPrintPallets, getNumberOfPalletsToPrint };
